const CSV_TEMPLATE_COLUMNS = [
  'No',
  'Full Name',
  'Amount',
  'Currency',
  "Receiver's Bank Name",
  "Receiver's Account No",
  'Paid From Bank Name',
  'Date (YYYY-MM-DD)',
];

const escapeCsvCell = (value: string) => {
  const escaped = value.replace(/"/g, '""');
  return `"${escaped}"`;
};

const toSafeFileNamePart = (value?: string | null) => {
  if (!value?.trim()) {
    return 'csv-import';
  }

  return value
    .trim()
    .toLowerCase()
    .replace(/[\/\\]+/g, ' ')
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '') || 'salary-import';
};

export const downloadCsvTemplate = (categoryName?: string | null) => {
  const headerRow = CSV_TEMPLATE_COLUMNS.map(escapeCsvCell).join(',');
  const csvContent = `${headerRow}\n`;

  const safeCategoryPart = toSafeFileNamePart(categoryName);
  const fileName = `${safeCategoryPart}-template.csv`;

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = window.URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  window.URL.revokeObjectURL(url);
};